var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"member-item-image-wrapper"},[_c('user-avatar',{attrs:{"shape":"circle","isGlobalScot":_vm.member.is_global_scot,"authorExist":!!_vm.member,"size":_vm.size,"width":`${_vm.size}px`,"src":_vm.member.avatar,"alt":"Profile picture","add-border":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }